var VehicleHistoryEditModal = (function (base) {
    __extends(VehicleHistoryEditModal, base);

    function VehicleHistoryEditModal(apiClient) {
    var self = base.call(this, apiClient) || this;
    return self;
  };

    VehicleHistoryEditModal.prototype.activate = function (historyId, vehicleId) {
    const self = this;

    const isNew = !historyId;
    const url = isNew ? 'api/vehicles/{0}/history/add'.format(vehicleId) : 'api/vehicles/{0}/history/{1}/edit'.format(vehicleId, historyId);
    var currentTrackerId = '';

    this.loadContent(url)
      .then($modal => {

          var $form = $('form', $modal);
          FormHelper.init($form, isNew ? 'PUT' : 'POST', 'api/vehicles/{0}/history'.format(vehicleId));

            datetimepickerInit({ $input: $('#Date', $modal), withSeconds: true });
            $('.select2', $form).select2({
                tags: true,
                dropdownParent: $modal,
                placeholder: 'Выберите или введите ID трекера',
                matcher: function (params, data) {
                    if (params.term) {
                        if (data.id === params.term)
                            return null;
                        if (data.id.indexOf(params.term) > -1)
                            return data;
                        return null;
                    }
                    else
                        return data;
                }
            });

            $modal

                //Кнопка `Сохранить`
                .on('click', '[js=save]', function() {
                    $modal.busy();
                    $modal.find('#TrackerId').val($('[js=tracker-id]').val());
                    $form.send()
                        .then((data) => self.close({ ok: true, trackerNumber: data.trackerNumber, trackerType: data.trackerType }))
                        .catch(() => $modal.busy(false));
                })
                .on('change', '[js=dismantled]', function() {
                    if (this.checked) {
                        currentTrackerId = $('[js=tracker-id]').val();
                        $('[js=tracker-id]').val('').trigger("change");
                        $('[js=tracker-id]').prop("disabled", true);;
                    } else {
                        if (currentTrackerId) {
                            $('[js=tracker-id]').val(currentTrackerId).trigger("change");
                        }
                        $('[js=tracker-id]').prop("disabled", false);;
                    }
                });
        });
  };

    return VehicleHistoryEditModal;
}(BaseModal));
